import Vue from 'vue'
import VueRouter from 'vue-router'

import datEmbededViewComplaints from '@/views/embeded/datEmbededViewComplaints.vue'

import { publicPath } from '../../vue.config'

Vue.use(VueRouter)

const routes = [
  { 
    path: '/embeded/ecanaldenuncias',
    name: 'ecanaldenuncias',
    component: datEmbededViewComplaints
  }
]

const router = new VueRouter({
  base: publicPath,
  routes,
})

export default router